import type { TypeContextCourant } from "@/features/auth/context-app"
import { SilentError } from '@/features/shared/types'

export const TransitionType = ['automatique', 'interactif'] as const
export type TransitionType = typeof TransitionType[number]

export interface Etat<TModel = unknown> {
  readonly nom: string
  readonly model: TModel
  readonly transitionType: TransitionType
  readonly transtionState?: any
}

abstract class TransitionError extends SilentError {}
export class TransitionCancel extends TransitionError {}
export class TransitionBack extends TransitionError {}

export type TransitionOut<TOut> =
  { out: TOut }
  & ({ type: 'automatique' } | { type: 'interactif', transitionState?: any })
  & { goBack?: false }

export type RunOptions<TIn> =
  {
    modelIn: TIn,
    canGoBack: boolean,
    titre: string,
    contextCourant: TypeContextCourant,
    transitionState: any
  }
export type Run<TIn, TOut>
  = (options: RunOptions<TIn>) => (TransitionOut<TOut> | Promise<TransitionOut<TOut>>)

export type Runnable<TIn, TOut> = {
  run: Run<TIn, TOut>
}
export type TransitionCallbackOptions<TLaunchParams> = { etats: Record<string, any>, launchParams?: TLaunchParams, contextCourant: TypeContextCourant }
export type TransitionCallback<TLaunchParams, TResult> = (options: TransitionCallbackOptions<TLaunchParams>) => TResult

export type Transition<TIn, TOut, TLaunchParams = any> = {
  etatDepart: string | null | Array<string | null>
  etatArrive: string
  runnable: Runnable<TIn, TOut> | (() => Runnable<TIn, TOut>),
  queryIn?: TransitionCallback<TLaunchParams, TIn>,
  if?: TransitionCallback<TLaunchParams, boolean>
}

export type Transitions<TLaunchParams = any> = Transition<any, any, TLaunchParams>[]

